import * as THREE from "three";
import loader from "./texture-loader";

export default class TextureLibrary {
  constructor(patterns, types) {
    this.typeTextures = {};

    types.forEach(type => {
      this.typeTextures[type.key] = {};

      [
        "overlay",
        "pattern_id",
        "normal_map",
        "ao_map",
        "metallic_map",
        "roughness_map",
        "emission_map",
        "alpha_map"
      ].forEach(map => {
        if (type[map] !== null) {
          let texture = loader.load(type[map]);
          // If texture is used for color information, set colorspace.
          texture.encoding = THREE.sRGBEncoding;
          // UVs use the convention that (0, 0) corresponds to the upper left corner of a texture.
          texture.flipY = false;

          this.typeTextures[type.key][map] = { url: type[map], texture };
        }
      });
    });

    this.patterns = patterns.reduce((accum, pattern) => {
      let texture = loader.load(pattern.texture);
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      // If texture is used for color information, set colorspace.
      texture.encoding = THREE.sRGBEncoding;
      // UVs use the convention that (0, 0) corresponds to the upper left corner of a texture.
      texture.flipY = false;

      accum[pattern.name] = {
        url: pattern.texture,
        texture
      };

      return accum;
    }, {});
  }

  getPattern(name) {
    return this.patterns[name].texture;
  }

  getMapNamesForType(type) {
    return Object.entries(this.typeTextures[type])
      .map(([name, data]) => name)
      .filter(i => i);
  }

  getMap(mapName, type) {
    return this.typeTextures[type][mapName].texture;
  }
}
